<ng-container 
    *appLet="{
        culture: culture$ | async,
        isModifyWidget: isModifyWidget$ | async,
        featIsOnUS606: gbs.growthBook.isOn(gbf.FEAT_US606_MAIN_TEXT_FRONTPAGE_SEARCH),
        featStringValueUS606: gbs.growthBook.getFeatureValue(gbf.FEAT_US606_MAIN_TEXT_FRONTPAGE_SEARCH, ''),
    } as $comp">
    <div class="search-header">
        @if ($comp.isModifyWidget) {
            <h2 class="search-header__text center">
                {{ cmsCopy.modifySearch }}
            </h2>
        } @else {
            <h2 class="search-header__text">
                @if (
                    ['en-US', 'en-GB'].includes($comp.culture || FALLBACK_CULTURE) &&
                    $comp.featIsOnUS606
                ) {
                    @switch ($comp.featStringValueUS606) {
                        @case ('b') {
                            Where are you flying?
                        }
                        @case ('c') {
                            Where can we take you?
                        }
                        @case ('d') {
                            Book now
                        }
                        @case ('e') {
                            Let's go!
                        }
                        @case ('f') {
                    
                        }
                        @default {
                            {{ cmsCopy.whereToExplorer }}
                        }
                    }
                } @else {
                    {{ cmsCopy.whereToExplorer }}
                }
            </h2>
        }
    </div>
</ng-container>
